import { Table, Select, Input } from "antd";
import {
  Search,
  FileText,
  Youtube,
  ReceiptText,
  NotebookPen,
  Package,
  Files,
} from "lucide-react";
import useSWR from "swr";
import Pdf from "../../../assets/images/pdf.png";
import { UPLOADS_URL, fetcher } from "../../../lib/apiConstants";
import { useState } from "react";
const { Option } = Select;

const DocumentationLibraryInfo = () => {
  const tabs = [
    {
      key: "manuals",
      label: "Manuals",
      icon: <FileText className="w-6 h-6" />,
    },
    {
      key: "spec-sheets",
      label: "Spec Sheets",
      icon: <ReceiptText className="w-6 h-6" />,
    },
    {
      key: "cut-sheets",
      label: "Cut Sheets",
      icon: <Files className="w-6 h-6" />,
    },
    {
      key: "application-notes",
      label: "Application Notes",
      icon: <NotebookPen className="w-6 h-6" />,
    },
    {
      key: "product-release-notes",
      label: "Release Notes",
      icon: <Package className="w-6 h-6" />,
    },
    // {
    //   key: "video-library",
    //   label: "Video Library",
    //   icon: <Youtube className="w-6 h-6" />,
    // },
  ];
  const [selectedTab, setSelectedTab] = useState(tabs[0].key);
  const [searchQuery, setSearchQuery] = useState("");
  const [sort, setSort] = useState("updated_desc");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [visibleCount, setVisibleCount] = useState(10);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const LOAD_INCREMENT = 10;
  const pageSize = 10;
  const { data: products, isLoading: productsLoading } = useSWR(
    "products/",
    fetcher
  );
  const { data: categories, isLoading: categoriesLoading } = useSWR(
    "categories/",
    fetcher
  );
  // const { data: videos, isLoading: videosLoading } = useSWR(
  //   selectedTab === "video-library" ? "videos/" : null,
  //   fetcher
  // );

  const categoryFields = {
    manuals: [
      "user_manual_link",
      // "quick_guide_link",
      // "wire_diagram_link",
      // "network_guide_link",
    ],
    "spec-sheets": ["flyer_link"],
    "cut-sheets": ["others_link"],
    "application-notes": ["application_note_link"],
    "product-release-notes": [],
    // "video-library": [],
  };
  let allDocuments = [];
  // if (selectedTab === "video-library") {
  //   if (videos) {
  //     let filteredVideos = videos;
  //     if (selectedCategory !== "All") {
  //       filteredVideos = videos.filter(
  //         (video) => video.category === selectedCategory
  //       );
  //     }
  //     allDocuments = filteredVideos.map((video) => ({
  //       id: video.id,
  //       name: video.name,
  //       url: video.link,
  //       updated: video.updated_at
  //         ? video.updated_at.split("T")[0].replace(/-/g, ".")
  //         : "N/A",
  //       type: "video",
  //     }));
  //   }
  // } else
  if (products) {
    let filteredProducts = products;
    if (selectedCategory !== "All") {
      filteredProducts = products.filter(
        (product) => product.category === selectedCategory
      );
    }
    const seen = new Set();
    filteredProducts.forEach((product) => {
      (categoryFields[selectedTab] || []).forEach((field) => {
        const link = product[field];
        if (link && link !== "") {
          const name = link.split("/").pop();
          const key = link;
          if (!seen.has(key)) {
            seen.add(key);
            // FIX: Get the updated_at from the separate timestamp field
            const updatedAtField = field + "_updated_at";
            const updated_at = product[updatedAtField];
            const updated = updated_at
              ? updated_at.split("T")[0].replace(/-/g, ".")
              : "N/A";
            allDocuments.push({
              id: allDocuments.length,
              name,
              url: link,
              updated,
              type: selectedTab === "video-library" ? "video" : "pdf",
            });
          }
        }
      });
    });
  }
  let documents = allDocuments.filter((d) =>
    d.name.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const sortFunctions = {
    updated_desc: (a, b) => b.updated.localeCompare(a.updated),
    updated_asc: (a, b) => a.updated.localeCompare(b.updated),
    name_asc: (a, b) => a.name.localeCompare(b.name),
    name_desc: (a, b) => b.name.localeCompare(a.name),
  };
  if (sortFunctions[sort]) {
    documents.sort(sortFunctions[sort]);
  }

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const paginatedDocuments = documents.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );
  const total = documents.length;

  // Load More logic
  const displayedDocuments = documents.slice(0, visibleCount);
  const hasMore = visibleCount < documents.length;
  const remainingCount = documents.length - visibleCount;

  const handleLoadMore = () => {
    setIsLoadingMore(true);
    setTimeout(() => {
      setVisibleCount((prev) => prev + LOAD_INCREMENT);
      setIsLoadingMore(false);
    }, 300);
  };

  // Amazon-style Pagination Component
  const AmazonPagination = () => {
    const totalPages = Math.ceil(total / pageSize);

    const getPageNumbers = () => {
      const pages = [];
      const maxVisible = 5;

      if (totalPages <= maxVisible + 2) {
        // Show all pages if total is small
        for (let i = 1; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        // Always show first page
        pages.push(1);

        if (currentPage > 3) {
          pages.push("...");
        }

        // Show pages around current
        const start = Math.max(2, currentPage - 1);
        const end = Math.min(totalPages - 1, currentPage + 1);

        for (let i = start; i <= end; i++) {
          if (!pages.includes(i)) {
            pages.push(i);
          }
        }

        if (currentPage < totalPages - 2) {
          pages.push("...");
        }

        // Always show last page
        if (!pages.includes(totalPages)) {
          pages.push(totalPages);
        }
      }

      return pages;
    };

    if (totalPages <= 1) return null;

    return (
      <div className="flex items-center justify-center gap-1 mt-8">
        {/* Previous Button */}
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`px-3 py-1.5 text-sm rounded-sm border transition-all ${currentPage === 1
              ? "bg-[#f7f8f8] text-[#565959] border-[#d5d9d9] cursor-not-allowed opacity-60"
              : "bg-white text-[#0F1111] border-[#d5d9d9] hover:bg-[#f7f8f8] hover:border-[#c7c7c7] cursor-pointer"
            }`}
        >
          <span className="flex items-center gap-1">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
              <path
                d="M7.5 2L3.5 6l4 4"
                stroke="currentColor"
                strokeWidth="1.5"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Previous
          </span>
        </button>

        {/* Page Numbers */}
        {getPageNumbers().map((page, index) => {
          if (page === "...") {
            return (
              <span
                key={`ellipsis-${index}`}
                className="px-3 py-1.5 text-sm text-[#565959]"
              >
                ...
              </span>
            );
          }

          return (
            <button
              key={page}
              onClick={() => handlePageChange(page)}
              className={`min-w-[36px] px-2.5 py-1.5 text-sm rounded-sm border transition-all ${currentPage === page
                  ? "bg-[#016FFC] text-white border-[#016FFC] font-medium cursor-default"
                  : "bg-white text-[#0F1111] border-[#d5d9d9] hover:bg-[#f7f8f8] hover:border-[#c7c7c7] cursor-pointer"
                }`}
            >
              {page}
            </button>
          );
        })}

        {/* Next Button */}
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`px-3 py-1.5 text-sm rounded-sm border transition-all ${currentPage === totalPages
              ? "bg-[#f7f8f8] text-[#565959] border-[#d5d9d9] cursor-not-allowed opacity-60"
              : "bg-white text-[#0F1111] border-[#d5d9d9] hover:bg-[#f7f8f8] hover:border-[#c7c7c7] cursor-pointer"
            }`}
        >
          <span className="flex items-center gap-1">
            Next
            <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
              <path
                d="M4.5 2l4 4-4 4"
                stroke="currentColor"
                strokeWidth="1.5"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </button>
      </div>
    );
  };

  const columns = [
    {
      title: "File Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <a
          href={
            record.type === "pdf" ? `${UPLOADS_URL}${record.url}` : record.url
          }
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-gray-600 font-medium hover:text-blue-800 hover:underline transition-colors"
        >
          {record.type === "pdf" ? (
            <img src={Pdf} alt="PDF" className="w-4 h-4.5 flex-shrink-0" />
          ) : (
            <Youtube className="w-5 h-5 flex-shrink-0 text-red-600" />
          )}
          <span className="break-words">{text}</span>
        </a>
      ),
    },
    {
      title: "Last Updated",
      dataIndex: "updated",
      key: "updated",
      width: 180,
    },
  ];

  return (
    <div className="max-w-[1200px] max-xl:max-w-full mx-auto max-xl:mx-6 pt-4 md:pt-6 lg:pt-16">
      {/* Cards/Tabs Section */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-3">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => {
              setSelectedTab(tab.key);
              setCurrentPage(1);
              setVisibleCount(10);
            }}
            className={`flex flex-col justify-center items-center gap-3 font-medium rounded-lg   transition-all px-3 py-4 min-h-[120px] border ${selectedTab === tab.key
                ? "bg-blue-700 text-white shadow-lg border-blue-600"
                : "bg-gray-100 text-black hover:bg-gray-200 border-gray-300"
              }`}
          >
            {tab.icon}
            <span className="text-center  font-['Poppins']">{tab.label}</span>
          </button>
        ))}
      </div>
      {/* Filter Section */}
      <div className="flex flex-col sm:flex-row gap-4 pt-4 mb-7 w-full">
        <Select
          value={selectedCategory}
          onChange={(value) => {
            setSelectedCategory(value);
            setCurrentPage(1);
            setVisibleCount(10);
          }}
          className="h-12 w-auto min-w-[280px]"
          placeholder="Select category"
          loading={categoriesLoading}
        >
          <Option value="All">All</Option>
          {categories?.map((cat) => (
            <Option key={cat.id} value={cat.name}>
              {cat.name.charAt(0).toUpperCase() + cat.name.slice(1)}
            </Option>
          ))}
        </Select>
        <div className="flex-1 min-w-0">
          <Input
            placeholder="Search here"
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              setCurrentPage(1);
              setVisibleCount(10);
            }}
            prefix={<Search className="text-gray-400 w-5 h-5" />}
            allowClear
            className="h-12"
          />
        </div>
      </div>
      {/* Table Section */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-4 overflow-x-auto">
        <Table
          columns={columns}
          dataSource={displayedDocuments}
          loading={productsLoading || categoriesLoading}
          pagination={false}
          rowKey="id"
          className="documentation-table"
          bordered={true}
        />
      </div>

      {/* Results Info & Load More */}
      {documents.length > 0 && !productsLoading && !categoriesLoading && (
        <>
          {/* Results Counter */}
          <div className="text-center mt-6 text-sm text-[#565959]">
            Showing{" "}
            <span className="font-medium text-[#0F1111]">
              {visibleCount > documents.length
                ? documents.length
                : visibleCount}
            </span>{" "}
            of{" "}
            <span className="font-medium text-[#0F1111]">
              {documents.length}
            </span>{" "}
            documents
          </div>

          {/* Load More Button */}
          {hasMore && (
            <div className="mt-6 mb-12">
              <div className="flex flex-col items-center gap-3">
                <button
                  onClick={handleLoadMore}
                  disabled={isLoadingMore}
                  className={`px-10 py-3 min-w-[240px] border border-[#d5d9d9] rounded-sm text-sm font-medium transition-all duration-200 ${isLoadingMore
                      ? "bg-[#f7f8f8] text-[#565959] cursor-not-allowed opacity-70"
                      : "bg-white text-[#0F1111] hover:bg-[#f7f8f8] hover:border-[#c7c7c7] active:bg-[#ededed] shadow-sm hover:shadow-md"
                    }`}
                >
                  {isLoadingMore ? (
                    <span className="flex items-center justify-center gap-2">
                      <svg
                        className="animate-spin h-4 w-4"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        />
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        />
                      </svg>
                      Loading More...
                    </span>
                  ) : (
                    `Load More Documents (${remainingCount} remaining)`
                  )}
                </button>

                {/* Helper Text */}
                <p className="text-xs text-[#767676]">
                  Click to load {Math.min(LOAD_INCREMENT, remainingCount)} more
                  documents
                </p>
              </div>
            </div>
          )}

          {/* End of Results */}
          {!hasMore && (
            <div className="text-center mt-8 mb-4 py-6 border-t border-[#e7e7e7]">
              <div className="flex flex-col items-center gap-2">
                <svg
                  className="w-12 h-12 text-[#d5d9d9]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <p className="text-sm font-medium text-[#0F1111]">
                  You've viewed all {documents.length} documents
                </p>
                <button
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className="mt-2 px-4 py-2 text-sm text-[#016FFC] hover:text-[#C7511F] hover:underline transition-colors"
                >
                  ↑ Back to top
                </button>
              </div>
            </div>
          )}
        </>
      )}

      {/* Amazon-style Pagination (kept but now unused — remove if not needed) */}
      {/* {total > 0 && !productsLoading && <AmazonPagination />} */}
      <style jsx>{`
        @import url("https://fonts.googleapis.com/css2?family=Poppins:wght@600&display=swap");
        :global(.documentation-table .ant-table) {
          border: none;
        }
        :global(.documentation-table .ant-table-thead > tr > th) {
          background: #fafafa;
          font-weight: 600;
          padding: 20px;
          border-bottom: 2px solid #e8e8e8;
          border-right: 1px solid #ddd;
        }
        :global(.documentation-table .ant-table-thead > tr > th:last-child) {
          border-right: none;
        }
        :global(.documentation-table .ant-table-tbody > tr > td) {
          padding: 20px;
          border-right: 1px solid #ddd;
        }
        :global(.documentation-table .ant-table-tbody > tr > td:last-child) {
          border-right: none;
        }
        :global(.documentation-table .ant-table-tbody > tr > td:first-child) {
          display: flex;
          align-items: center;
          gap: 10px;
          flex: 1 0 0;
          align-self: stretch;
        }
        :global(.documentation-table .ant-table-tbody > tr > td:last-child) {
          width: 180px;
          padding: 20px;
          display: flex;
          align-items: center;
          gap: 10px;
          align-self: stretch;
        }
        :global(.documentation-table .ant-table-tbody > tr:hover) {
          background: #f9fafb;
        }
        :global(.ant-select-selector) {
          height: 48px !important;
          padding: 16px !important;
          display: flex !important;
          align-items: center !important;
        }
        :global(.ant-select-selection-item) {
          display: flex !important;
          align-items: center !important;
        }
        :global(.ant-input-affix-wrapper) {
          padding: 16px !important;
          display: flex !important;
          align-items: center !important;
        }
      `}</style>
    </div>
  );
};
export default DocumentationLibraryInfo;
